import React, { useState, forwardRef, useImperativeHandle } from "react";
import styles from "./index.modules.less";
import Close from "../../image/close.svg";

const NoAccess = forwardRef(({}, ref) => {
  const [modelShow, setModelShow] = useState(false);

  useImperativeHandle(
    ref,
    () => {
      return {
        show: () => {
          setModelShow(true);
        },
        hide: () => {
          setModelShow(false);
        },
      };
    },
    []
  );

  if (!modelShow) {
    return null;
  }

  return (
    <div className={styles.AccessModal}>
      <span
        onClick={() => {
          setModelShow(false);
          location.href = "/login";
        }}
      >
        <Close className={styles.close}></Close>
      </span>

      <div className={styles.modalTit}>认证权限提醒</div>
      <div className={styles.modalInfo}>
        很抱歉，您暂无联运权限。
        如果有联运合作诉求，请您联系：安全卫士商务组邮件{" "}
        <a href="mailto:g-global-bd@360.cn">g-global-bd@360.cn</a>
      </div>
      <div
        onClick={() => {
          setModelShow(false);
          location.href = "/login";
        }}
        className={styles.modalBtn}
      >
        知道了
      </div>
    </div>
  );
});

export default NoAccess;
